// @flow
import cookieUtils from '../../utils/cookieUtils';
import {LOCATION_COOKIE} from '../../utils/locationData';
import {makeUpdatedSERPUrl} from '../../utils/routerUtils';

import type {SearchQueryCompleteAction} from '../../actions/searchQuery';
import type {Store} from '../../reducers/index';

export default function setLocationData(
    store: Store,
    {payload}: SearchQueryCompleteAction
) {
    const state = store.getState();
    if (payload.results) {
        const lbsKeywords = payload.results.searchTerm
            ? payload.results.searchTerm.description
            : null;
        const params = {
            ...payload.variables.params,
            ...payload.variables.request,
            q: lbsKeywords
        };

        const haStatePersistCookie = cookieUtils.readCookie(LOCATION_COOKIE);

        if (lbsKeywords) {
            haStatePersistCookie.lbsKeywords = lbsKeywords;
        }

        haStatePersistCookie.lastSearchUrl = makeUpdatedSERPUrl(
            params,
            ['include'],
            state,
            {
                canonicalizeKeywords: false
            }
        );
        cookieUtils.writeCookie(LOCATION_COOKIE, haStatePersistCookie);
    }
}
